/**
 * Copyright 2018 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *     http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export { createElement, cloneElement, Component, createContext, createRef, render, hydrate, toChildArray } from 'preact';

export { useState, useReducer, useEffect, useLayoutEffect, useRef, useImperativeHandle, useMemo, useCallback, useContext, useDebugValue, useErrorBoundary, useId } from 'preact/hooks';
// import { /*signal, computed, effect, batch,*/ untracked, useSignal, useComputed, useSignalEffect } from '@preact/signals';
export { createPortal } from 'preact/compat'
// export * from '@preact/signals-core'

import { h } from 'preact';
import htm from '../../index.mjs';

export const html = htm.bind(h);
